import React from 'react';
import './LeadGenThankYou.scss';

const LeadGenThankYou = props => {
  const { backToHome, message, buttonText } = props;
  const isDesktop = Boolean(process.env.CLIENT_TYPE === 'desktop');
  const goToHome = () => {
    backToHome();
  };

  return (
    <div className="div-container">
      <div className="thankyou-div">
        <div>
          <img alt="true" className="" src="/assets/svg/true-icon.svg" />
        </div>
        <div className="thankyou-text">Thank You!!</div>
        <div className="thankyou-msg fsp14 fs12">{`${message}`}</div>
      </div>
      <div className={`${isDesktop ? 'width50' : 'width95'} btn-container`}>
        <button
          className="fsp18 fs18 fw500 text-uppercase"
          onClick={() => goToHome()}
        >{`${buttonText}`}</button>
      </div>
    </div>
  );
};

export default LeadGenThankYou;
